/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createSeasonFromDiscriminatorValue, type ProblemDetails, type Season } from '../../models/index.js';
// @ts-ignore
import { type WithIsActiveItemRequestBuilder, WithIsActiveItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Season/{id}
 */
export interface SeasonItemRequestBuilder extends BaseRequestBuilder<SeasonItemRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.Season.item.item collection
     * @param isActive Unique identifier of the item
     * @returns {WithIsActiveItemRequestBuilder}
     */
     byIsActive(isActive: boolean) : WithIsActiveItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Season>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Season | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SeasonItemRequestBuilderUriTemplate = "{+baseurl}/Season/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SeasonItemRequestBuilderNavigationMetadata: Record<Exclude<keyof SeasonItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byIsActive: {
        requestsMetadata: WithIsActiveItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["isActive"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SeasonItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SeasonItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSeasonFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
